// extracted by mini-css-extract-plugin
module.exports = {"comics":"Comics_comics__2b1rg","noResults":"Comics_noResults__3XuUo"};